import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface PriceChangeEntry {
  date: string | null;
  new_selling_price: number | null;
}

export interface ItemPriceHistoryResponse {
  item_code: string;
  price_changes: PriceChangeEntry[];
}

export const getItemPriceHistory = async (
  itemCode: string
): Promise<ItemPriceHistoryResponse> => {
  try {
    const response: ApiResponse<ItemPriceHistoryResponse | null> = (
      await apiClient.get(`/pos_pricechange/item-price-history/${encodeURIComponent(itemCode)}`, {
        headers: {
          "x-skip-auth-redirect": "true",
        },
      })
    ).data;

    return (
      response.data || { item_code: itemCode, price_changes: [] }
    );
  } catch (error: any) {
    if (error?.response?.status === 401) {
      throw new Error(
        "Not authorized to load price history. Please sign in with backend authentication."
      );
    }

    if (error?.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }

    throw new Error("Failed to fetch price history");
  }
};